import { Box } from "@mui/material"
import useWaterlinePermissions from "../../../../hooks/useWaterlinePermissions"
import AddResultButton from "./AddResultButton"
import { Dispatch, SetStateAction } from "react"
import { OpenLogResultModal } from "../types"

type NoTestResults = {
  setOpenModal: Dispatch<SetStateAction<OpenLogResultModal>>,
  hasInOfficeTesting: boolean,
}

const NoTestResults = (props: NoTestResults) => {
  const { setOpenModal, hasInOfficeTesting } = props

  const waterLinePermissions = useWaterlinePermissions()

  return (
    <>
      <Box sx={{ marginBottom: '15px', display: 'flex', justifyContent: 'flex-end' }}>
        {
          hasInOfficeTesting
            && waterLinePermissions.inOffice.add
            && <AddResultButton setOpenModal={setOpenModal} />
        }
      </Box>
      <Box>
        No active tests
      </Box>
    </>
  )
}

export default NoTestResults
